module.exports = __webpack_public_path__ + "img/changZuiHu3.6c1d755c.png";